import { render, staticRenderFns } from "./PersonalWallpaperDetail.vue?vue&type=template&id=22722f80&scoped=true&"
import script from "./PersonalWallpaperDetail.vue?vue&type=script&lang=js&"
export * from "./PersonalWallpaperDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersonalWallpaperDetail.vue?vue&type=style&index=0&id=22722f80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22722f80",
  null
  
)

export default component.exports